import script from "./project.vue?vue&type=script&setup=true&lang=ts"
export * from "./project.vue?vue&type=script&setup=true&lang=ts"

import "./project.vue?vue&type=style&index=0&id=589096fe&scoped=true&lang=scss"
import "./project.vue?vue&type=style&index=1&id=589096fe&scoped=true&lang=css"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-589096fe"]])

export default __exports__